import { TenantConfig } from "@lxp-app/assets/config/tenantConfig.types";
import { createSlice } from "@reduxjs/toolkit";
import localTenantConfig from "@lxp-app/assets/config/tenantConfig.json";

export interface AppMetaDataSliceState {
  languageData: any;
  footer: boolean;
  breadcrumb: boolean;
  header: boolean;
  agendaBufferTime: number | null;
  pollingLimit: number | null;
  isFeedbackModalOpen: boolean;
  videoUrlRefetchInterval: number | null;
  tenantConfig: TenantConfig;
}

export const AppMetaDataSlice = createSlice({
  name: "AppMetaDataSlice",
  initialState: {
    languageData: {},
    sourceFilterData: {},
    footer: true,
    breadcrumb: true,
    header: false,
    agendaBufferTime: 0,
    pollingLimit: 0,
    eventCancellationBufferTime: 0,
    roles: [],
    isFeedbackModalOpen: false,
    videoUrlRefetchInterval: 0,
    tenantConfig: {} as TenantConfig
  },
  reducers: {
    setLanguageData(state, action) {
      state.languageData = action.payload;
    },
    setSourceFilterData(state, action) {
      state.sourceFilterData = action.payload;
    },
    setViewFooter(state, action) {
      state.footer = action.payload;
    },
    setViewBreadcrumb(state, action) {
      state.breadcrumb = action.payload;
    },
    setViewHeader(state, action) {
      state.header = action.payload;
    },
    setAgendaBufferTime(state, action) {
      state.agendaBufferTime = action.payload;
    },
    setPollingLimit(state, action) {
      state.pollingLimit = action.payload;
    },
    setEventCancellationBuffer(state, action) {
      state.eventCancellationBufferTime = action.payload;
    },
    setRoles(state, action) {
      state.roles = action.payload;
    },
    setFeedbackModalOpen(state, action) {
      state.isFeedbackModalOpen = action.payload;
    },
    setRefetchInterval(state, action) {
      state.videoUrlRefetchInterval = action.payload;
    },
    setTenantConfig(state, action) {
      state.tenantConfig = action.payload;
    }
  }
});

export default AppMetaDataSlice;

export const AppMetaDataSliceActions = AppMetaDataSlice.actions;
